import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ParagraphSelector from "../features/assignment/components/common/ParagraphSelector";
import SectionSelector from "../features/assignment/components/common/SectionSelector";

import {
  fetchParagraphList,
  fetchSectionList,
  setParagraph,
  setSection,
  retreiveAssignment,
} from "../features/assignment/assignmentSlice";
import TopBar from "../features/assignment/components/widgets/TopBar";
import SectionPage from "../features/assignment/components/common/SectionPage";
import { checkStudent, checkUser } from "../features/student/studentSlice";

const ReviewPage = () => {
  const dispatch = useDispatch();
  const { paragraphList, sectionList } = useSelector(
    (state) => state.assignment
  );
  const [selectedParagraph, setSelectedParagraph] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const assignmentId = queryParams.get("id");

    const session = queryParams.get("session");
    const type = queryParams.get("type");

    if (session) {
      try {
        const decoded = atob(session);
        const [id, randomCode] = decoded.split(":");
        if (type === "student")
          dispatch(checkStudent({ studentId: id, randomCode: randomCode }));
        else dispatch(checkUser({ userId: id, randomCode: randomCode }));

        if (assignmentId) {
          try {
            dispatch(retreiveAssignment(assignmentId));
            dispatch(fetchParagraphList(assignmentId));
          } catch (error) {
            alert("잘못된 URL입니다.");
          }
        } else {
          alert("잘못된 URL입니다.");
        }
      } catch (error) {
        alert("잘못된 URL입니다.");
      }
    } else {
      alert("잘못된 URL입니다.");
    }
  }, [dispatch]);

  const handleSelectParagraph = (paragraph) => {
    setSelectedParagraph(paragraph);
  };

  const handleCompleteParagraphSelection = () => {
    if (!selectedParagraph) {
      alert("지문을 선택해주세요.");
      return;
    }
    dispatch(setParagraph(selectedParagraph));
    dispatch(fetchSectionList(selectedParagraph.id));
    setCurrentStep(2);
  };

  const backToParagraphSelection = () => {
    setCurrentStep(1);
  };

  const handleSelectSection = (section) => {
    setSelectedSection(section);
  };

  const handleCompleteSectionSelection = () => {
    if (!selectedSection) {
      alert("섹션을 선택해주세요.");
      return;
    }
    dispatch(setSection(selectedSection));
    setSelectedSection(null);
    setCurrentStep(3);
  };

  const renderContent = () => {
    if (currentStep === 1) {
      return (
        <ParagraphSelector
          paragraphList={paragraphList}
          selectedParagraph={selectedParagraph}
          setSelectedParagraph={handleSelectParagraph}
          handleNext={handleCompleteParagraphSelection}
          isReview={true}
        />
      );
    } else if (currentStep === 2) {
      return (
        <SectionSelector
          sectionList={sectionList}
          selectedSection={selectedSection}
          setSelectedSection={handleSelectSection}
          handleNext={handleCompleteSectionSelection}
          handleBefore={backToParagraphSelection}
          isReview={true}
        />
      );
    } else {
      return <SectionPage setCurrentStep={setCurrentStep} isReview={true} />;
    }
  };

  return (
    <div
      style={{
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#F6F8FA",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        userSelect: "none",
      }}
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <div
        style={{
          padding: "0px 40px",
          height: "calc(100vh - 70px)",
        }}
      >
        <TopBar
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          isReview={true}
        />
        {renderContent()}
      </div>
    </div>
  );
};

export default ReviewPage;
